import * as PickImage from "expo-image-picker";
import { useCallback } from "react";
import { UseImagePickerProps } from "./ImagePicker.types";

export function useImagePicker({ onPicked, base64 }: UseImagePickerProps) {
  const pickImage = useCallback(async () => {
    // No permissions request is necessary for launching the image library
    let result = await PickImage.launchImageLibraryAsync({
      mediaTypes: PickImage.MediaTypeOptions.Images,
      allowsEditing: false,
      quality: 1,
      allowsMultipleSelection: false,
      selectionLimit: 1,
      base64,
    });

    if (result.canceled) {
      return;
    }

    const img = result.assets[0];

    const contentType = img.uri.startsWith("data:") ? img.uri.split(";")[0].replace("data:", "") : "image/jpg";

    onPicked({ uri: img.uri, name: img.fileName, base64: img.base64, contentType });
  }, [onPicked, base64]);

  return { pickImage };
}
